export default {
  404: 'No fue posible obtener la información del empleado',
};
